<template>
<div style="background-color: #fafafa; z-index: 9999" class="content">
<div class="mod" style="height: 100vh;">
  <div class="box">
    <div class="color" />
    <div class="bd">
      <div class="group_2">
        <div class="group_3">
          <span class="text">姓名</span>
          <div class="container_1">
            <span class="txt_1" @click="autofocus('customerName')" >  <input type="text" :disabled='disabled' id="customerName" v-model.trim="customerName" placeholder="请填写您的姓名"  style="border: none"></span>
            <div class="wrap" @click="autofocus('customerName')">
              <img
                class="icon_5"
                src="/static/img/修 改.svg"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="block_3">
        <img
          class="bg"
          src="/static/img/authentication13.png"
        />
        <div class="container_2">
          <span class="word_1">手机</span>
          <div class="outer_1">
            <span class="phone">{{mobile}}</span>
            <div class="block_4">
              <img
                class="icon_6"
                src="/static/img/锁.svg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submain">
      <span class="info">1. 请确保您的姓名为</span>
      <span class="word_2">真实姓名，</span>
      <span class="info_1">否则会导致</span>
      <span class="txt_2">签署失败</span>
    </div>
    <div class="row">
      <span class="info_2">2. 请确保您的姓名与</span>
      <span class="organizationPrev">手机号码实名机主</span>
      <span class="organization">一致</span>
    </div>
    <div class="row1">
      <span class="word_3">3. 手机号已</span>
      <span class="text_1">开通支付宝</span>
    </div>
    <span class="desc">4. 手机号为登录时使用手机号，无法更改</span>
    <div class="footer">
      <div class="footer-content" style="text-align: center">
        <div style="width: 100%;">
  <div style="
height: 14px;
font-size: 10px;
font-weight: 300;
color: #929292;
line-height: 14px;margin-bottom: 10px;text-align: center">
       点击发起签署，<span style="color:#5878FA;">e签宝</span>认证链接会以<span style="color:#5878FA;">短信</span>形式发送到您的手机上
          </div>
          <div class="add-btn research-background-color" @click="goShowConfirmedButton" style="text-align: center; padding-top: 12px"><span>发起签署</span></div></div>
      </div>
      <footer-placeholder></footer-placeholder>
    </div>
  </div>
</div>
  <div class="background-modal"  v-if="showConfirmedButton"></div>
  <div class="choose-balance-account" style="margin-bottom: 350px;margin-left: 10%;margin-right: 10%;border-radius: 12px;" v-show="showConfirmedButton">
    <div class="content-block" style="text-align: center">
      <div style="justify-content: center;margin-top:15px;margin-bottom:10px;">
        <span class="deep-text-color" style="text-align: center;width: 272px;height: 24px;font-size: 17px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #000000;line-height: 24px;">确认信息</span>
      </div>
      <div class="message_customer">
        <div>
        <span>姓名: </span> <span>{{customerName}}</span></div>
        <div> <span>手机: </span> <span>{{mobile}}</span></div>
      </div>
      <div style="height: 70px;">
        <img
          class="bg_1"
          src="/static/img/authentication13.png"
        />
        <div style="margin-top: 5px">
        <div style="float:left;width: 50%;"  @click="showConfirmedButton = false">
         <span>
           返回修改
         </span>
        </div>
        <div style="float: right;width: 50%" @click="sendAuthentication">
          <span style="color:#576B95" >确认发起</span>
        </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import {mapGetters, mapState} from 'vuex'
  // import emkt from '../../emkt.js'
  import FooterPlaceholder from '../../views_v_2.6/components/FooterPlaceholder.vue'
  export default {
    mounted () {
      if (this.$route.query.customerNo !== this.sessionInfo.customerInfo.customerNo) {
        this.disabled = true
      }
    },
    created () {
      this.fetchData()
    },
    data () {
      return {
        disabled: false,
        orderId: this.$route.query.orderId,
        customerName: '',
        mobile: '',
        canEdit: true,
        showConfirmedButton: false
      }
    },
    components: {
      FooterPlaceholder
    },
    computed: {
      ...mapGetters([
        'hasLogin', 'isWapp'
        // ...
      ]),
      ...mapState([
        'sessionInfo'
      ])
    },
    methods: {
      fetchData () {
        if (this.sessionInfo.customerInfo) {
          // 获取最新的客户信息
          this.gcapi('gcwwwifc/getCustomerWithoutLogin?customerNo=' + this.sessionInfo.customerInfo.customerNo).then(response => {
            if (response.body.result) {
              this.customerName = response.body.result.customerName
              this.mobile = response.body.result.mobile
            } else {
              this.customerName = this.sessionInfo.customerInfo.customerName
              this.mobile = this.sessionInfo.customerInfo.mobile
            }
          })
        }
      },
      goShowConfirmedButton () {
        var title = '姓名: ' + this.customerName + '</br>' + '手机：' + this.mobile
        var _this = this
        _this.$weui.confirm(title, {
          title: '确认实名信息',
          buttons: [{
            label: '返回修改',
            type: 'default',
            onClick: function () { console.log('no') }
          }, {
            label: '确认发起',
            type: 'primary',
            onClick: function () { _this.sendAuthentication() }
          }]
        })
      // this.showConfirmedButton = true
      },
      sendAuthentication () {
        var _this = this
        var authenticationInfo = {
          customerName: this.customerName,
          mobile: this.mobile,
          orderId: this.orderId
        }
        _this.$weui.loading('正在发送短信')
        _this.gcapi('startEmktSignFlowByCustomer', authenticationInfo)
                  .then((response) => {
                    _this.$weui.loading().hide()
                    if (response.body.message !== '') {
                      _this.$weui.toast(response.body.message, 3000)
                    } else {
                      _this.$weui.toast('短信已经发送！', 3000)
                      _this.$router.push({name: 'sendAuthentication', params: {authenticationInfo: authenticationInfo}, query: {orderId: this.orderId, canShow: true, time: 60}})
                    }
                  }, (response) => {
                    console.log(response.body.message)
                    _this.$weui.toast(response.body.message, 2500)
                  })
      },
      autofocus (id) {
        $('#' + id).focus()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .box {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    background-color: #fafafa;
    overflow: hidden;
  }

  .color {
    position: absolute;
    top: 254px;
    right: -1px;
    border-style: solid;
    border-color: #efeef3;
    background-color: #ffffff;
    width: 1px;
    height: 131px;
  }

  .hd {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    background-color: #ffffff;
    height: 88px;
  }
.message_customer {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  width: 272px;
  color: #BDBDBD;

}
  .group {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    margin-top: 17px;
    margin-left: 34px;
  }
  .deep-text-color {
    color: #424242;
    font-size: 14px;
    font-weight: bold;
  }
  .txt {
    margin-top: 7px;
    margin-right: 232px;
    max-width: 248px;
    height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 19px;
    letter-spacing: 0px;
    white-space: nowrap;
    color: #ffffff;
    font-family: SFProText-Semibold, SF Pro Text;
    font-size: 15px;
    font-weight: 600;
  }
  .container {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
  }

  .icon {
    margin-right: 5px;
    width: 17px;
    height: 12px;
  }

  .icon_1 {
    margin-right: 5px;
    width: 16px;
    height: 12px;
  }

  .outer {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    border-color: rgba(255, 255, 255, 0.35);
    width: 22px;
    height: 11px;
  }

  .colorDiv {
    border-radius: 1px;
    background-color: #ffffff;
    width: 18px;
    height: 7px;
  }

  .dot {
    width: 2px;
    height: 4px;
  }

  .block {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 7px;
    margin-left: 17px;
  }

  .icon_2 {
    margin-right: 128px;
    width: 9px;
    height: 18px;
  }

  .word {
    margin-right: 60px;
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 17px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-weight: 500;
  }

  .block_1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-style: solid;
    border-radius: 16px;
    border-color: rgba(151, 151, 151, 0.2);
    background-color: rgba(255, 255, 255, 0.6);
    height: 32px;
  }

  .block_2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    width: 44px;
  }

  .icon_3 {
    width: 19px;
    height: 7px;
  }

  .color_1 {
    margin-right: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    width: 1px;
    height: 18px;
  }

  .group_1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 41px;
  }

  .icon_4 {
    width: 18px;
    height: 18px;
  }

  .bd {
    display: flex;
    position: relative;
    align-items: flex-start;
    align-self: center;
    flex-direction: column;
    margin-top: 10px;
    border-radius: 10px;
    border: 1px solid #EFEEF3;
    background-color: #ffffff;
  }

  .group_2 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    height: 59px;
  }

  .group_3 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 20px;
  }

  .text {
    margin-right: 40px;
    max-width: 56px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 500;
    margin-left: 16px;
  }

  .container_1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
  }

  .txt_1 {
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #929292;
    font-size: 14px;
    font-weight: 400;
  }

  .wrap {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: -2px;
    margin-left: -18px;
  }

  .icon_5 {
    width: 15px;
    height: 16px;
  }

  .block_3 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 1px;
    height: 61px;
  }

  .bg {
    position: relative;
    margin-top: -1px;
    margin-left: 15px;
    width: 340px;
    height: 1px;
  }

  .container_2 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 20px;
    margin-left: 16px;
  }

  .word_1 {
    margin-right: 40px;
    max-width: 56px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 500;
  }

  .outer_1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 20px;
  }

  .phone {
    margin-right: 10px;
    max-width: 115px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #929292;
    font-size: 14px;
    font-weight: 400;
  }

  .block_4 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-left: 70px;
    margin-top: -4px;
  }

  .icon_6 {
    width: 13px;
    height: 16px;
  }

  .submain {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 15px;
    margin-left: 21px;
    height: 21px;
  }

  .info {
    margin-top: 1px;
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .word_2 {
    margin-top: -1px;
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .info_1 {
    margin-top: 1px;
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .txt_2 {
    margin-top: 1px;
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 5px;
    margin-left: 21px;
    height: 20px;
  }

  .info_2 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .organizationPrev {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .organization {
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row1 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 5px;
    margin-left: 21px;
    height: 20px;
  }

  .word_3 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .text_1 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .desc {
    position: relative;
    margin-top: 4px;
    margin-left: 21px;
    max-width: 354px;
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row2 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 280px;
  }

  .empty {
    position: relative;
    height: 0;
  }

  .group_4 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    margin-top: 1px;
  }

  .bg_1 {
    position: relative;
    margin-top: -1px;
    width: 100%;
    height: 1px;
  }

  .block_5 {
    display: flex;
    position: fixed;
    bottom: 0;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    margin-top: 72px;
    background-color: #ffffff;
    width: 100%;
    height: 50px;
  }

  .colorDiv_1 {
    margin-top: 37px;
    border-radius: 2px;
    background-color: #000000;
    width: 134px;
    height: 5px;
  }

  .group_5 {
    display: flex;
    position: fixed;
    bottom: 80px;
    align-items: flex-start;
    align-self: center;
    flex-direction: column;
    background-color: #ffffff;
    width: 100%;
    height: 86px;
  }

  .block_6 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    margin-top: 14px;
    height: 15px;
  }

  .info_3 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #929292;
    font-size: 10px;
    font-weight: 300;
  }

  .text_2 {
    margin-top: 1px;
    line-height: 10px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 10px;
    font-weight: 400;
  }

  .info_4 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #929292;
    font-size: 10px;
    font-weight: 300;
  }

  .word_4 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 10px;
    font-weight: 400;
  }

  .info_5 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #929292;
    font-size: 10px;
    font-weight: 300;
  }

  .tagWrap {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 12px;
    margin-left: 25px;
    border-radius: 22px;
    background-color: #5878fa;
    width: 350px;
    height: 44px;
  }

  .tag {
    max-width: 338px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }

  .row3 {
    background-color: #fafafa;
    width: 375px;
    height: 812px;
    overflow: hidden;
    display: flex;
    position: relative;
    align-items: flex-start;
    margin-top: 360px;
  }

  .row4 {
    border-style: solid;
    border-color: #efeef3;
    background-color: #ffffff;
    width: 1px;
    height: 131px;
    display: flex;
    position: relative;
    align-items: flex-start;
    margin-top: 360px;
  }

  .row5 {
    border-style: solid;
    border-radius: 10px;
    border-color: #efeef3;
    background-color: #ffffff;
    width: 355px;
    height: 121px;
    display: flex;
    position: relative;
    align-items: flex-start;
    margin-top: 360px;
  }

  .row6 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .word_5 {
    line-height: 14px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 500;
  }

  .row7 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .text_3 {
    line-height: 14px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 500;
  }

  .row8 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .phoneNum {
    line-height: 14px;
    white-space: nowrap;
    color: #929292;
    font-size: 14px;
    font-weight: 400;
  }

  .row9 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .word_6 {
    line-height: 14px;
    white-space: nowrap;
    color: #929292;
    font-size: 14px;
    font-weight: 400;
  }

  .row10 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 360px;
  }

  .div {
    margin-right: 340px;
    width: 0;
    height: 1px;
  }

  .bgWrap {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 0;
  }

  .bg_2 {
    margin-left: -340px;
    width: 340px;
    height: 1px;
  }

  .row11 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
    margin-top: 360px;
  }

  .empty_1 {
    position: relative;
    width: 375px;
    height: 0;
  }

  .group_6 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 1px;
    width: 375px;
  }

  .bg_3 {
    position: relative;
    margin-top: -1px;
    width: 375px;
    height: 1px;
  }

  .container_3 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    margin-top: 72px;
    background-color: #ffffff;
    width: 375px;
    height: 50px;
  }

  .colorDiv_2 {
    margin-top: 37px;
    border-radius: 2px;
    background-color: #000000;
    width: 134px;
    height: 5px;
  }


  .color_2 {
    border-radius: 1px;
    background-color: #ffffff;
    width: 18px;
    height: 7px;
  }

  .dot_1 {
    width: 2px;
    height: 4px;
  }

  .group_8 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 10px;
    margin-left: 17px;
  }

  .icon_9 {
    margin-right: 128px;
    width: 9px;
    height: 18px;
  }

  .txt_4 {
    margin-right: 60px;
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 17px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-weight: 500;
  }

  .container_5 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-style: solid;
    border-radius: 16px;
    border-color: rgba(151, 151, 151, 0.2);
    background-color: rgba(255, 255, 255, 0.6);
    height: 32px;
  }

  .group_9 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    width: 44px;
  }

  .icon_10 {
    width: 19px;
    height: 7px;
  }

  .colorDiv_3 {
    margin-right: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    width: 1px;
    height: 18px;
  }

  .container_6 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 41px;
  }

  .icon_11 {
    width: 18px;
    height: 18px;
  }

  .row13 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 360px;
  }

  .icon_12 {
    width: 13px;
    height: 16px;
  }

  .row14 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 360px;
  }

  .icon_13 {
    width: 15px;
    height: 16px;
  }

  .row15 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .info_9 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row16 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .text_6 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row17 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .info_10 {
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row18 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .word_7 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row19 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .info_11 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row20 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .info_12 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row21 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .company {
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row22 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .text_7 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row23 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .txt_5 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row24 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 360px;
  }

  .desc_1 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row25 {
    background-color: rgba(0, 0, 0, 0.55);
    height: 812px;
    display: flex;
    position: relative;
    align-items: flex-start;
    margin-top: 360px;
  }

  .main {
    border-radius: 12px;
    background-color: #ffffff;
    width: 320px;
    height: 232px;
    display: flex;
    position: relative;
    align-items: flex-start;
    margin-top: 360px;
  }

  .row26 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 360px;
  }

  .div_1 {
    margin-right: 320px;
    width: 0;
    height: 1px;
  }

  .bgWrap_1 {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 0;
  }

  .bg_4 {
    margin-left: -320px;
    width: 320px;
    height: 1px;
  }

  .row27 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 24px;
    position: relative;
    margin-top: 360px;
  }

  .text_8 {
    line-height: 17px;
    letter-spacing: 1px;
    white-space: nowrap;
    color: #576b95;
    font-size: 17px;
    font-weight: 500;
  }

  .row28 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 24px;
    position: relative;
    margin-top: 360px;
  }

  .txt_6 {
    line-height: 17px;
    letter-spacing: 1px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-weight: 500;
  }

  .row29 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 360px;
  }

  .empty_2 {
    margin-right: 1px;
    width: 0;
    height: 56px;
  }

  .group_10 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 0;
  }

  .verticalLine {
    width: 1px;
    height: 56px;
  }

  .row30 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    position: relative;
    margin-top: 360px;
  }

  .info_13 {
    webkit-box-orient: vertical;
    display: -webkit-inline-box;
    webkit-line-clamp: 2;
    width: 102px;
    height: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.5);
    font-size: 17px;
    font-weight: 400;
  }

  .ft {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 24px;
    position: relative;
    margin-top: 360px;
  }

  .info_14 {
    line-height: 17px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-weight: 500;
  }
  .background-modal {
    opacity: 0.55;
    background: #000000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
  }
  .choose-balance-account{
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 10px;
    z-index: 20;
    font-size: 14px;
    color: #979797;
  }
  .content-block {
    position: relative;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 0 15px;
    border-radius: 10px;
    width: 100%;
    border: 0.5px solid #EFEEF3;
    background-color: #fff;
  }
  .footer {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    font-size: 14px;
    background-color: #fff;
  }

  .footer-content {
    display: flex;
    align-items: center;
    align-self: center;
    flex-direction: row;
    background-color: #ffffff;
    width: 100%;
    height: 86px;
    padding: 0px 10px;
  }

  .add-btn {
    width: 100%;
    height: 44px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    border-radius: 44px;
  }
  .tag {
    color: #ffffff;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    position: absolute;
    margin-top: 12px;
    margin-left: -45px;
  }
</style>



// WEBPACK FOOTER //
// authenticationHome.vue?181bc0ff